import { Routes } from '@angular/router';

import { PERSONAL_DETAILS_PAGE_URL } from '../dashboard/personal-details/personal-details.page';
import { errorRoutes } from '../not-found-error/not-found-error.page';
import { ADMIN_LOCATIONS_PAGE_URL } from './drop-off-locations/drop-off-locations.page';
import { ADMIN_LOCATION_PAGE_URL } from './drop-off-locations/pages/drop-off-location.page';
import { ADMIN_JOBS_PAGE_URL } from './jobs/jobs.page';
import { ADMIN_JOB_PAGE_URL } from './jobs/pages/job/job.page';
import { ADMIN_ORGANISATIONS_PAGE_URL } from './organisations/organisations.page';
import {
  ADMIN_ORGANISATION_PAGE_URL
} from './organisations/pages/organisation/organisation-details/organisation-details.component';
import { ADMIN_ORGANISATION_USER_DETAILS_PAGE_URL } from './organisations/pages/organisation/organisation-users-list/user-details/user-details.page';
import { ADMIN_USERS_PAGE_URL } from './users/users.page';

export const adminRoutes: Routes = [
  // ORGANISATIONS
  {
    path: ADMIN_ORGANISATIONS_PAGE_URL,
    loadComponent: () =>
      import('./organisations/organisations.page').then(
        (m) => m.OrganisationsPage,
      ),
    title: 'Organisations | Alpha Scientific',
  },
  {
    path: ADMIN_ORGANISATION_PAGE_URL,
    loadComponent: () =>
      import('./organisations/pages/organisation/organisation.page').then(
        (m) => m.OrganisationPage,
      ),
    title: 'Organisation details | Alpha Scientific',
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './organisations/pages/organisation/organisation-details/organisation-details.component'
          ).then((m) => m.OrganisationDetailsComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import(
            './organisations/pages/organisation/organisation-users-list/organisation-users-list.component'
          ).then((m) => m.AdminOrganisationUsersListComponent),
      },
      {
        path: 'users/:userId',
        loadComponent: () =>
          import('./organisations/pages/organisation/organisation-users-list/user-details/user-details.page').then(
            (m) => m.AdminOrganisationUserDetailsPage,
          ),
      },
      {
        path: 'suites',
        loadComponent: () =>
          import(
            './organisations/pages/organisation/organisation-suites/suites.component'
          ).then((m) => m.AdminOrganisationSuitesComponent),
      },
      {
        path: 'suites/:suiteCode',
        loadComponent: () =>
          import(
            './organisations/pages/organisation/organisation-suites/suite-details/suite-details.component'
          ).then((m) => m.AdminOrganisationSuiteDetailsComponent),
      },
    ],
  },

  // USERS
  {
    path: ADMIN_USERS_PAGE_URL,
    loadComponent: () => import('./users/users.page').then((m) => m.UsersPage),
    title: 'Users | Alpha Scientific',
  },
  // USERS / USER DETAILS
  {
    path: ADMIN_ORGANISATION_USER_DETAILS_PAGE_URL,
    loadComponent: () =>
      import('./users/pages/user-details/user-details.page').then(
        (m) => m.AdminUserDetailsPage,
      ),
    title: 'User details | Admin - Alpha Scientific',
  },

  // DROP-OFF LOCATIONS
  {
    path: ADMIN_LOCATIONS_PAGE_URL,
    loadComponent: () =>
      import('./drop-off-locations/drop-off-locations.page').then(
        (m) => m.DropOffLocationsPage,
      ),
    title: 'Drop-off locations | Alpha Scientific',
  },

  // DROP-OFF LOCATION
  {
    path: ADMIN_LOCATION_PAGE_URL,
    loadComponent: () =>
      import('./drop-off-locations/pages/drop-off-location.page').then(
        (m) => m.DropOffLocationPage,
      ),
    title: ({ params }) => `${params['id'] || 'Loading..'} | Alpha Scientific`,
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './drop-off-locations/pages/drop-off-location-details/drop-off-location-details.component'
          ).then((m) => m.DropOffLocationDetailsComponent),
      },
    ],
  },

  // JOBS
  {
    path: ADMIN_JOBS_PAGE_URL,
    loadComponent: () => import('./jobs/jobs.page').then((m) => m.JobsPage),
    title: 'Job | Alpha Scientific',
  },

  // JOB
  {
    path: ADMIN_JOB_PAGE_URL,
    loadComponent: () =>
      import('./jobs/pages/job/job.page').then((m) => m.JobPage),
    title: ({ params }) =>
      `${params['jobId'] || 'Loading..'} | Alpha Scientific`,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./jobs/pages/job/job-details/job-details.component').then(
            (m) => m.JobDetailsComponent,
          ),
      },
      {
        path: 'samples',
        loadComponent: () =>
          import('./jobs/pages/job/job-samples/job-samples.component').then(
            (m) => m.JobSamplesComponent,
          ),
      },
      {
        path: 'samples/:sampleId',
        loadComponent: () =>
          import('./jobs/pages/job/job-samples/sample/sample.page').then(
            (m) => m.SamplePage,
          ),
        title: ({ params }) =>
          `${params['sampleId'] || 'Loading..'} | Alpha Scientific`,
      },
      {
        path: 'documents',
        loadComponent: () =>
          import('./jobs/pages/job/job-documents/job-documents.component').then(
            (m) => m.JobDocumentsComponent,
          ),
      },
    ],
  },
  // PERSONAL DETAILS
  {
    path: PERSONAL_DETAILS_PAGE_URL,
    loadComponent: () =>
      import('../dashboard/personal-details/personal-details.page').then(
        (m) => m.PersonalDetailsPage,
      ),
    title: 'Personal details | Alpha Scientific',
  },
  ...errorRoutes,
];
